module.exports = __webpack_public_path__ + "static/media/crownOff_118.928324f2.png";